import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const CouponManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Kupon Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Kupon yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default CouponManagement;
